import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_CLUSTERS_INFO,
	SET_LOADING,
	SET_PROCESSING_RESULT,
	SET_ENODEB_PAIRING_LOADING,
	SET_ENODEB_PAIRING_RESULT,
	GENERATE_REGENERATION_AUDIT_REQUEST,
	GENERATE_REGENERATION_AUDIT_SUCCESS,
	GENERATE_REGENERATION_AUDIT_FAILURE,
	RUN_ERICSSON_AUDIT_REQUEST,
	RUN_ERICSSON_AUDIT_SUCCESS,
	RUN_ERICSSON_AUDIT_FAILURE,
	PROCESS_ALARMS_DIFF_REQUEST,
	PROCESS_ALARMS_DIFF_SUCCESS,
	PROCESS_ALARMS_DIFF_FAILURE,
	RUN_NOKIA_DESC_CHECKS_REQUEST,
	RUN_NOKIA_DESC_CHECKS_SUCCESS,
	RUN_NOKIA_DESC_CHECKS_FAILURE,
	RUN_NOKIA_DESCRIPTION_DIFF_REQUEST,
	RUN_NOKIA_DESCRIPTION_DIFF_SUCCESS,
	RUN_NOKIA_DESCRIPTION_DIFF_FAILURE
} from '../actions/ScriptsGenerationActions';

const initialState = {
	clustersInfo: [],
	isLoading: false,
	processingResult: null,
	isEnodebPairingLoading: false,
	enodebPairingResult: null,
	regenerationAudit: {
		isLoading: false,
		result: null,
		error: null
	},
	ericssonAudit: {
		isLoading: false,
		result: null,
		error: null
	},
	alarmsDiff: {
		isLoading: false,
		result: null,
		error: null
	},
	nokiaDescriptionChecks: {
		isLoading: false,
		result: null,
		error: null
	},
	nokiaDescriptionDiff: {
		isLoading: false,
		result: null,
		error: null
	},
	formState: {
		values: {
			deploymentDate: new Date(),
			excelInputFile: null,
			enodebPairingExcelFile: null,
			auditExcelFile: null,
			ericssonAuditExcelFile: null,
			alarmsDiffZipFile: null,
			nokiaDescriptionDiffExcelFile: null
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const scriptsGenerationReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							formState: {
								...initialState.formState
							},
							processingResult: null,
							enodebPairingExcelFile: null,
							regenerationAudit: {
								isLoading: false,
								result: null,
								error: null
							},
							ericssonAudit: {
								isLoading: false,
								result: null,
								error: null
							},
							nokiaDescriptionDiff: {
								isLoading: false,
								result: null,
								error: null
							}
						};
					}
					case GET_CLUSTERS_INFO: {
						return {
							...state,
							clustersInfo: action.clustersInfo
						};
					}
					case SET_LOADING: {
						return {
							...state,
							isLoading: action.isLoading
						};
					}
					case SET_PROCESSING_RESULT: {
						return {
							...state,
							processingResult: action.result
						};
					}
					case SET_ENODEB_PAIRING_LOADING: {
						return {
							...state,
							isEnodebPairingLoading: action.isLoading
						};
					}
					case SET_ENODEB_PAIRING_RESULT: {
						return {
							...state,
							enodebPairingResult: action.result
						};
					}
					case GENERATE_REGENERATION_AUDIT_REQUEST:
						return {
							...state,
							regenerationAudit: {
								isLoading: true,
								result: null,
								error: null
							}
						};
					case GENERATE_REGENERATION_AUDIT_SUCCESS:
						return {
							...state,
							regenerationAudit: {
								isLoading: false,
								result: action.payload,
								error: null
							}
						};
					case GENERATE_REGENERATION_AUDIT_FAILURE:
						return {
							...state,
							regenerationAudit: {
								isLoading: false,
								result: null,
								error: action.payload
							}
						};
					case RUN_ERICSSON_AUDIT_REQUEST:
						return {
							...state,
							ericssonAudit: {
								isLoading: true,
								result: null,
								error: null
							}
						};
					case RUN_ERICSSON_AUDIT_SUCCESS:
						return {
							...state,
							ericssonAudit: {
								isLoading: false,
								result: action.payload,
								error: null
							}
						};
					case RUN_ERICSSON_AUDIT_FAILURE:
						return {
							...state,
							ericssonAudit: {
								isLoading: false,
								result: null,
								error: action.payload
							}
						};
					case PROCESS_ALARMS_DIFF_REQUEST:
						return {
							...state,
							alarmsDiff: { isLoading: true, result: null, error: null }
						};
					case PROCESS_ALARMS_DIFF_SUCCESS:
						return {
							...state,
							alarmsDiff: { isLoading: false, result: action.payload, error: null }
						};
					case PROCESS_ALARMS_DIFF_FAILURE:
						return {
							...state,
							alarmsDiff: { isLoading: false, result: null, error: action.payload }
						};
					case RUN_NOKIA_DESC_CHECKS_REQUEST:
						return {
							...state,
							nokiaDescriptionChecks: {
								isLoading: true,
								result: null,
								error: null
							}
						};
					case RUN_NOKIA_DESC_CHECKS_SUCCESS:
						return {
							...state,
							nokiaDescriptionChecks: {
								isLoading: false,
								result: action.payload,
								error: null
							}
						};
					case RUN_NOKIA_DESC_CHECKS_FAILURE:
						return {
							...state,
							nokiaDescriptionChecks: {
								isLoading: false,
								result: null,
								error: action.payload
							}
						};
					case RUN_NOKIA_DESCRIPTION_DIFF_REQUEST:
						return {
							...state,
							nokiaDescriptionDiff: {
								isLoading: true,
								result: null,
								error: null
							}
						};
					case RUN_NOKIA_DESCRIPTION_DIFF_SUCCESS:
						return {
							...state,
							nokiaDescriptionDiff: {
								isLoading: false,
								result: action.payload,
								error: null
							}
						};
					case RUN_NOKIA_DESCRIPTION_DIFF_FAILURE:
						return {
							...state,
							nokiaDescriptionDiff: {
								isLoading: false,
								result: null,
								error: action.payload
							}
						};
					default: {
						return state;
					}
	}
};

export default scriptsGenerationReducer;
